import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { CTA } from '../Agents/CTA';
import { Footer } from '../Agents/Footer';
import Nav from '../Agents/Nav';
import BusinessIntelligenceHero from './BusinessIntelligenceHero';
import BusinessIntelligenceHowItWorks from './BusinessIntelligenceHowItWorks';
import BusinessIntelligenceFAQ from './BusinessIntelligenceFAQ';

const BusinessIntelligence = (props) => {
  const [responseStatus, setResponseStatus] = useState(null);

  async function submitHandler(formData) {
    const API_URL = "https://bx9x6sd0rf.execute-api.eu-central-1.amazonaws.com/prod/form_submit";

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          title: formData.jobTitle,
          company: formData.company,
          website: "", // honeypot — must stay empty, real users never see/fill this
        }),
      });

      const data = await response.json();
      setResponseStatus(response.status);
      return data;
    } catch (err) {
      setResponseStatus(0);
      throw err;
    }
  }

  return (
    <View style={{ width: '100%', height: '100%' }}>
      <ScrollView>
        <Nav />
        <BusinessIntelligenceHero submitHandler={submitHandler} responseStatus={responseStatus} />
        <BusinessIntelligenceHowItWorks />
        <BusinessIntelligenceFAQ />
        <CTA
          heading="Talk to us about your reporting setup"
          buttonLabel="Contact us"
          submitHandler={submitHandler}
          responseStatus={responseStatus}
        />
        <Footer />
      </ScrollView>
    </View>
  );
};

export default BusinessIntelligence;
